import React from 'react';

import { AllSystemProps, allSystemProps } from 'shared/styles/props';

import styled from '@emotion/styled';

export interface TypographyProps extends AllSystemProps {
  className?: string;
  style?: React.CSSProperties;
  $ellipsis?: boolean;
}

export const Typography = styled.p<TypographyProps>(({ $ellipsis, ...rest }) => {
  const styles = { margin: 0, ...allSystemProps(rest) };

  if ($ellipsis) {
    Object.assign(styles, {
      width: '100%',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    });
  }

  return styles;
});
